import React, { useState } from 'react';
import axios from 'axios';
import '../styles/infoReserva.css'; 

const InfoReserva = () => {
    const [idReserva, setIdReserva] = useState('');
    const [reservaData, setReservaData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const bearerToken = process.env.REACT_APP_BEARER_TOKEN;

    const handleSearch = async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL_INFO_RESERVA}`, {
                headers: {
                    Authorization: `Bearer ${bearerToken}`
                },
                params: {
                    id_reserva: idReserva
                }
            });
            setReservaData(response.data);
        } catch (err) {
            setError('Error al cargar la información de la reserva.');
            console.error('Error al cargar la información de la reserva:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        setIdReserva(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch(); // Ejecuta la búsqueda cuando se presiona Enter
        }
    };

    return (
        <div className="info-reserva-container">
            <h1>Buscar Reserva</h1>
            <div className="search-bar">
                <label className="infoReserva-label" htmlFor="idReserva">ID Reserva:</label>
                <input
                    className="infoReserva-input"
                    type="text"
                    id="idReserva"
                    value={idReserva}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyPress} // Maneja el evento de la tecla Enter
                    placeholder="Ingrese el ID de la reserva"
                />
                <button className="infoReserva-button" onClick={handleSearch} disabled={loading}>
                    {loading ? 'Buscando...' : 'Buscar'}
                </button>
            </div>
            {error && <p className="error">{error}</p>}
            {reservaData && (
                <div className="json-container">
                    <pre>{JSON.stringify(reservaData, null, 2)}</pre>
                </div>
            )}
        </div>
    );
};

export default InfoReserva;
